<template>
  <app-layout>
    <PeopleListComponent :users="recentUsers"></PeopleListComponent>
  </app-layout>
</template>

<script>
import PeopleListComponent from '@/components/PeopleListComponent'

export default {
  name: 'PeopleComponent',
  components: {
    PeopleListComponent
  },
  data() {
    return {
      filter: ''
    }
  },
  methods:{
    searchPeople(){
      this.$store.dispatch("feed/searchRecentUsers",{text:this.filter, group_id:this.$route.query.id||'500E3120-B0F8-29C3-5D76-E43F66098341'}).then( 
          res=> {
            
          }, err=> {
            
        });
    },
  },
  computed: {
    recentUsers: {
      get () {
        return this.$store.state.feed.recentSearchUsers;
      }
    },
  },
  mounted(){
      this.searchPeople()
  }
}
</script>
